<template>
  <div class="card">
    <div class="card-header">
      <div class="bolder-title"> Отзывы по оценкам</div>

    </div>
    <div class="graph">
      <Bar v-if="datacollection"
           :options="chartOptions"
           :data="datacollection"
      />
    </div>
  </div>

</template>

<script>
import {ReviewApi} from "@/api/reviews";
import {Bar} from "vue-chartjs";
import {Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement} from 'chart.js'
import datesMixin from "@/mixins/filterDates";
import {handleChartClick} from "@/plugins/chartPlugin";


ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement)
export default {
  name: 'RatingGraphBar',
  components: {Bar},
  mixins: [datesMixin],
  data() {
    return {
      datacollection: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,
        onHover: (event, chartElement) => {
          event.native.target.style.cursor = chartElement.length ? 'pointer' : 'default';
        },
        onClick: handleChartClick(this.$router, (dataIndex) => ({
          ratings: [5, 4, 3, 2, 1][dataIndex]
        })),
        scales: {
          x:
              {
                stacked: true,
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: false,
                },
              },
          y:
              {
                stacked: true,
                grid: {
                  display: false
                },

              },

        },
        interaction: {
          mode: 'index',
          intersect: false,
        },

        plugins: {
          legend: {
            display: false,
          }
        }
      },
      charts: {
        1: this.$COLORS.negative,
        2: this.$COLORS.orange,
        3: this.$COLORS.yellow,
        4: this.$COLORS.positive_soft,
        5: this.$COLORS.positive
      }
    }
  },
  mounted: function () {
    this.getData();

  },
  computed: {},
  methods: {
    getData() {
      ReviewApi.rating_graph_bar(this.date_from, this.date_to).then(response => {
        let data = {
          label: "Количество отзывов",
          backgroundColor: [],
          borderColor: [],
          borderRadius: 5,
          borderWidth: 1,
          data: []
        }
        let labels = Array.from(Array(5).keys()).map(x => x + 1).reverse()
        labels.forEach(x => {
          data.backgroundColor.push(this.charts[x])
          data.borderColor.push(this.charts[x])
          data.data.push(response[x])
        })
        this.datacollection = {
          labels: labels.map(x => x + "★"),
          datasets: [data]
        }
      })
    }
  }
}

</script>
<style scoped lang="scss">
.graph {
  height: 250px;
}

</style>

